import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import SignIn from "../views/signIn";
import PublicHeader from "../containers/PublicHeader";
import PublicFooter from "../containers/PublicFooter";

const PublicRoutes = () => {
  return (
    <Router>
      <PublicHeader />
      <Switch>
        <Route exact path="/acceso" component={SignIn} />
        <Route path="*" component={() => <Redirect to="/acceso" />} />
      </Switch>
      <PublicFooter />
    </Router>
  );
};

export default PublicRoutes;
